const ROOT = 'dashboard/settings/location/neighborhoods';

export default {
	arrayList: `${ROOT}/list`,
	arrayListToDropdown: `${ROOT}/by-city/`,
	store: `${ROOT}`,
	show: `${ROOT}/`,
	status: `${ROOT}/status/`,
	update: `${ROOT}/`,
	destroy: `${ROOT}/`,
};
